import { Component, OnInit } from '@angular/core';
import { AngularFirestore} from '@angular/fire/compat/firestore';
import {FormBuilder, FormGroup,Validators} from "@angular/forms";
import { DatePipe } from '@angular/common';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.css']
})
export class AppointmentsComponent implements OnInit {
  minDate: Date;
  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Allow Thursday (4), Friday (5), and Saturday (6); block Sunday through Wednesday (0-3)
    return day !== 0 && day !== 1 && day !== 2 && day !== 3;
  }
  myForm: FormGroup;
  
  loading = false;
  success = false;

    constructor(
      private fb: FormBuilder,
      private afs: AngularFirestore,
      public datepipe: DatePipe, 
      public nav: NavbarService,
      private seo: SeoService
    ) { }
    
    ngOnInit() {
      this.seo.updateTags({
        title: 'Plan Your Visit & Tour Booking',
        description: 'Book a private group or school tour at Bayou Lacombe Museum. Open Saturdays 12-4 PM for general public, and Thursdays-Saturdays for scheduled group visits.',
        url: '/appointment'
      });
      this.minDate =new Date();
      this.myForm =this.fb.group({
        name:['',[
          Validators.required,
          Validators.pattern('[a-zA-Z .-]*'),
          
  
      ]],
        email:['',[
          Validators.required,
          Validators.email
        ]],
        phone:[''],
        date:['',[ Validators.required,
  
        ]],
        time:['',[ Validators.required,
  
        ]]
        
      });
      //this.myForm.valueChanges.subscribe(console.log)
    }
    get name(){
      return this.myForm.get('name');
    }
    get email(){
      return this.myForm.get('email');
    }
    get date(){
      return this.myForm.get('date')
    }
    get phone(){
      return this.myForm.get('phone')
    }
    get time(){
      return this.myForm.get('time')
    }
  submittedData = {
    name: '',
    email: '',
    phone: '',
    dateFormatted: '',
    time: ''
  };

  get mailtoLink(): string {
    const tourName = this.submittedData.name || this.myForm.value.name || '';
    const tourEmail = this.submittedData.email || this.myForm.value.email || '';
    const tourPhone = this.submittedData.phone || this.myForm.value.phone || 'None provided';
    const tourDate = this.submittedData.dateFormatted || '';
    const tourTime = this.submittedData.time || this.myForm.value.time || '';
    const subject = encodeURIComponent(`Private Tour Appointment Request - ${tourDate} at ${tourTime}`);
    const body = encodeURIComponent(
      `Hello Bayou Lacombe Museum,\n\nI have requested a private tour visit with the following details:\n\nName: ${tourName}\nEmail: ${tourEmail}\nPhone: ${tourPhone}\nRequested Date: ${tourDate}\nPreferred Time: ${tourTime}\n\nPlease confirm availability and details for our group. Looking forward to visiting!\n\nBest regards,\n${tourName}`
    );
    return `mailto:bayoulacombemuseum@gmail.com,info@bayoulacombemuseum.com?subject=${subject}&body=${body}`;
  }

  async onSubmit() {
    if (this.myForm.invalid) return;

    this.loading = true;
    const formattedDate = this.datepipe.transform(this.myForm.value.date, 'EEEE, MMMM d, y') || '';
    const formValue = {
      name: this.myForm.value.name,
      email: this.myForm.value.email,
      phone: this.myForm.value.phone || '',
      date: formattedDate,
      time: this.myForm.value.time,
      createdAt: new Date()
    };

    this.submittedData = {
      name: this.myForm.value.name,
      email: this.myForm.value.email,
      phone: this.myForm.value.phone || '',
      dateFormatted: formattedDate,
      time: this.myForm.value.time
    };

    try {
      await this.afs.collection('appointment').add(formValue);
      this.success = true;
    } catch (err) {
      console.error('Firestore appointment error:', err);
      this.success = true;
    } finally {
      this.loading = false;
    }
  }
}
  